import axios from 'axios';

export async function downloadReturnBatch(batchId) {
  const { data } = await axios.get(`/api/return-batches/${batchId}/xlsx`, {
    baseURL: process.env.REACT_APP_API_URL,
    withCredentials: true,
    responseType: 'blob',
  });
  const url = URL.createObjectURL(data);
  try {
    const link = document.createElement('a');
    link.href = url;
    link.download = `devoluciones-lote-${batchId}.xlsx`;
    document.body.appendChild(link);
    link.click();
    link.remove();
  } finally {
    window.setTimeout(() => URL.revokeObjectURL(url), 1000);
  }
}
